import { request } from './request';

export const userSignup = userInfo => {
  return request('/invitations/signup', 'POST', userInfo);
};
